<template>
  <b-container>
    <b-row>
      <b-col cols="1">

      </b-col>
      <b-col cols="10">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Entity Type:" label-for="input-sm">
          <b-form-select :options="entityTypes"
                         v-model="selectedEntityType"
                         v-on:change="selectEntityType">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="1">

      </b-col>
    </b-row>
    <b-row>
      <b-col cols="1">

      </b-col>
      <b-col cols="10">
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Notification Type:" label-for="input-sm">
          <b-form-select :options="notificationTypes" @change="notificationYearSelected"
                         v-model="selectedNotificationId"
                         :disabled="isAssignedNotificationEnabled">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="1">

      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">

        <editor
            api-key='hrb21ypd40shtmcr0kef33uwq67i8gd23ckbp5e2ex5znwt2'
            v-model="notificationContents "
            :init="{
         height: 500,
         menubar: true,
         mergetags_prefix: '*{',
         mergetags_suffix: '}*',
         mergetags_list:
         [
        {
          title: 'Client',
          menu: [
                {
                  value: 'client.givenname',
                  title: 'Given name'
                },
                {
                  value: 'client.familyname',
                  title: 'Family name'
                },
                {
                  value: 'client.company',
                  title: 'Company'
                }
                ]
        },
        {
          title: 'Schedule',
          menu: [
                {
                  value: 'submission.date',
                  title: 'Submission date'
                },
                {
                  value: 'completion.date',
                  title: 'Completion date'
                }
                ]
        },
        ],
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat |\
            link image fontcolor | help'
       }"/>
      </b-col>
    </b-row>
    <b-row style="padding-top: 3px">
      <b-col cols="4" class="text-center">
      </b-col>
      <b-col cols="4" class="text-center">
        <b-button id="saveButton" @click="saveChanges" :disabled="saveButtonEnable" :variant="saveButtonVariant">
          Save
        </b-button>
        <b-button id="testEmailButton" @click="sendTestEmail" :variant="saveButtonVariant" style="margin: 5px"
                  :disabled="testEmailButtonEnable">
          Test
        </b-button>
        <b-button id="cancelButton" @click="saveChanges" :disabled="saveButtonEnable" :variant="saveButtonVariant">
          Cancel
        </b-button>
      </b-col>
      <b-col cols="4" class="text-center">

      </b-col>
    </b-row>
  </b-container>

</template>
<script>

import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'NotificationEditor',
  components: {
    'editor': Editor
  },
  data() {
    //"Vineyard 6 Month", "Vineyard 3 Month", "Vineyard 1 Month",
    //"Winery 6 Month", "Winery 3 Month", "Winery 1 Month"
    return {
      notificationTypes: [{value: null, text: "Select A Notification Type"}],
      selectedNotificationId: null,
      notificationContents: "",
      saveButtonVariant: "success",
      saveButtonEnable: true,
      entityTypes: ["Select A Entity Type", "WINE", "VINEYARD"],
      selectedEntityType: "Select A Entity Type"
    }
  },
  mounted() {
    // let self = this;
    // this.$http.get("/notification/types/")
    //     .then(result => {
    //       console.log("Response: ", result.data);
    //       let entries = Object.entries(result.data);
    //       console.log("Entries: ", entries);
    //       entries
    //           .forEach(vsl => {
    //             self.notificationTypes.push({value: vsl[0], text: vsl[1].replaceAll("_", " ")});
    //           });
    //       console.log("Parent Companies: " + self.notificationTypes);
    //     })
    //     .catch(error => {
    //       console.log("The error: " + error);
    //     })

  },
  computed: {
    testEmailButtonEnable: function () {
      return this.selectedNotificationId === null;
    },
    isAssignedNotificationEnabled: function () {
      return this.selectedEntityType === "Select A Entity Type";
    },
  },
  methods: {
    loadNotifications: function () {
      let self = this;
      this.$http.get(`/notification/types/${self.selectedEntityType}`)
          .then(result => {
            console.log("Response: ", result.data);
            let entries = Object.entries(result.data);
            console.log("Entries: ", entries);
            entries
                .forEach(vsl => {
                  self.notificationTypes.push({value: vsl[0], text: vsl[1].replaceAll("_", " ")});
                });
            console.log("Notifications: ", self.notificationTypes);
            console.log(self.notificationTypes);
          })
          .catch(error => {
            console.log("The error: " + error);
          })
    },
    saveChanges: function () {
      let notificationUpdate = {
        _id: this.selectedNotificationId,
        text: this.notificationContents
      }
      console.log("Metrics Year");
      console.log(JSON.stringify(notificationUpdate));
      this.$http.put(`/notification/${notificationUpdate._id}`, JSON.stringify(notificationUpdate), {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        console.log(response);
        if (self.id === null) {
          self.id = response.data;
          self.metricId = self.id;
        }
        this.$toasted.info("Notification Saved", {
          containerClass: 'super-toasty',
          iconPack: 'fontawesome',
          closeOnSwipe: true,
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          icon: {
            name: 'fa-envelope-open',
            after: false
          }
        })
            .goAway(5000);
      }).catch(error => {
        console.log("Error Putting Data");
        console.error(error);
      })
    },
    sendTestEmail: function () {
      this.$http.post(`/notification/test/${this.selectedNotificationId}`, null, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(result => {
        console.log(result);
        this.$toasted.info("Test Email Sent", {
          containerClass: 'super-toasty',
          iconPack: 'fontawesome',
          closeOnSwipe: true,
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          icon: {
            name: 'fa-envelope-open',
            after: false
          }
        })
            .goAway(5000);

      }).catch(error => {
        console.log("Error Requesting test email");
        console.error(error);
        this.$toasted.info("Notification Was Unable To Be Sent", {
          containerClass: 'super-toasty',
          iconPack: 'fontawesome',
          closeOnSwipe: true,
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          icon: {
            name: 'fa-skull-crossbones',
            after: false
          }
        })
            .goAway(5000);
      })
    },
    notificationContentsEdited: function () {
      this.saveButtonEnable = false;
    },
    notificationYearSelected: function (selectedId) {
      this.getNotificationToEdit();
    },
    getNotificationToEdit: function () {
      console.log("Selected Notification Id: {}", this.selectedNotificationId);
      if (this.selectedNotificationId === null) {
        return;
      }
      let self = this;
      let notification_url = `notification/${self.selectedNotificationId}`;
      this.$http.get(notification_url)
          .then(result => {
            let notificationInfo = result.data;
            self.notificationContents = notificationInfo.text;
            this.loaded = true;
            console.log("Selected Notification Text: {}", notificationInfo);
            this.saveButtonEnable = false;
          })
          .catch(error => {
            console.log("Had issue pulling data:" + error.message);
            console.log(error)
          });
    },
    selectEntityType: function () {
      this.notificationTypes = [{value: null, text: "Select A Notification Type"}];
      if (this.selectedEntityType === "Select A Entity Type") {
        return;
      }
      console.debug("Loading Notifications");
      this.loadNotifications();
    }
  }
}
</script>


<style scoped>

</style>
